import { array, string } from 'fp-ts';
import { flow } from 'fp-ts/function';
import { createSelector } from 'reselect';
import { getEnterprisesByIds } from '@mews-commander/legacy-entities/src/ducks/enterprises';

export const getEnterprisesUniqDefaultLanguageCodes = createSelector(
    getEnterprisesByIds,
    flow(
        array.map(({ defaultLanguageCode }) => defaultLanguageCode),
        array.uniq(string.Eq)
    )
);

export const getEnterprisesUniqChainIds = createSelector(
    getEnterprisesByIds,
    flow(
        array.map(({ chainId }) => chainId),
        array.uniq(string.Eq)
    )
);
